
// import request from "@/utils/request.js";
import Vue from "vue";
import axios from "axios";

const BASE_URL = "https://h5.changefacepro.com";//线上 加wsh
// const BASE_URL = "http://192.168.0.66:8080/api";//公司内网  不加wsh
// const BASE_URL = "http://192.168.0.182:8010";//个人

const API = {
 /*
    发送验证码
  */ 
sendValidate:`/blade-resource/sms/endpoint/send-validate`,
onregister:`/blade-auth/oauth/token`

};
// //发送验证码
// export const sendValidate = data => {
//   return request({
//     method:"POST",
//     url:"/blade-resource/sms/endpoint/send-validate",
//     data
//   })
// }

// // 注册
// export const getToken = data => {
//   return request({
//     method:"POST",
//     url:"/blade-auth/oauth/token",
//     data
//   })
// }
  
const config = {
  API,
  BASE_URL
};
// 添加请求拦截器
const service = axios.create({
  // baseURL: config.BASE_URL,
  timeout: 30000
});
service.interceptors.request.use(
  config => {
    // 设置请求头信息
    // config.headers.Authorization = "Bearer " +  sessionStorage.getItem("token") || "";
    // config.headers['Content-Type'] = 'text/plain' // 请求头类型
    

    // if (config.method === "post") {
    //   config.data = Qs.stringify(config.data);
    // }
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
export default {
  service,
  BASE_URL,
  API
};


// WEBPACK FOOTER //
// ./src/http/index.js